module.exports = __webpack_public_path__ + "images/company/rank_medal/selling_agreement_count_rank/1_5c2dd8d48ab0f8adbb8c9ff847898d69.png";